var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"headline primary--text"},[(_vm.value)?_c('markdown',{attrs:{"source":_vm.value}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }